import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "shiftWork-template-setting-window",
  class: "template-setting-window",
  style: {"display":"flex"}
}
const _hoisted_2 = { class: "template-setting-window-header" }
const _hoisted_3 = { class: "template-setting-window-header-name" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("small", null, "Настройка отчета", -1)
const _hoisted_6 = { class: "overflow-auto" }
const _hoisted_7 = {
  key: 0,
  class: "column q-mb-sm not-excel",
  style: {"max-width":"400px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { class: "no-border" }, "Группировать по", -1)
const _hoisted_9 = { class: "no-border" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "undefined" }, "Не группировать", -1)
const _hoisted_11 = ["value", "innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "no-border" }, "Сортировать по", -1)
const _hoisted_13 = { class: "no-border" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "undefined" }, "Не сортировать", -1)
const _hoisted_16 = ["value", "innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "row q-mt-sm" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "padding-top-5 text-center" }, [
  /*#__PURE__*/_createElementVNode("small", null, "Окончание настройки отчета")
], -1)
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle2 no-margin" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-weight-bold" }, "Предупреждение")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, " Для избежания торможения сайта рекомендуем сократить интервал запроса. Рекомендуемый интервал - не более суток ")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = { class: "d-flex align-items-center justify-content-between" }

import { computed, watch, ref, onMounted } from 'vue';

import UiPopup from '@/ManualApp/Components/Popups/UiPopup.vue';

import {
  addHoverOnTargetByParent,
  removeHoverOnTargetByParent,
} from '@/App/helpers/targetsHelper';

import { getNeighborByClass_helper, setElementColor_helper } from '@/helpers/main_helper';

import {
  GROUP_BY_OPTIONS,
  SORT_BY_OPTIONS,
  DEFAULT_DESCENDING,
} from './Config';

import Diagnostic, { ReportName } from '@/Template/Diagnostic/Diagnostic';
import type { GroupBy, SortBy } from './Config';
import UIReportButton from '@/App/Monitoring/Sidebar/components/UIReportButton.vue';

interface Props {
  objects: string[];
  interval: { from: Date; to: Date };
  reportName: ReportName;
  areaId: string;
  buttonId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DiagnosticSettings',
  props: {
    objects: null,
    interval: null,
    reportName: null,
    areaId: null,
    buttonId: null
  },
  emits: ['close', 'displayReport'],
  setup(__props: any, { emit }) {

const props = __props as {
  objects: string[];
  interval: { from: Date; to: Date };
  reportName: ReportName;
  areaId: string;
  buttonId: string;
}




const MAX_DAYS_IN_INTERVAL = 1;

const warningPopup = ref(false);

const groupBy = ref<GroupBy>();

const sortBy = ref<SortBy>();
const descending = ref<boolean>(DEFAULT_DESCENDING);

const layout = ref(false);

const title = computed(() =>
  props.reportName === 'diagnostic'
    ? 'Диагностика'
    : props.reportName === 'descriptionDiagnostic'
    ? 'Диагностика ТС с описанием'
    : 'Диагностика (подробный)',
);

onMounted(() => {
  if (props.reportName === 'diagnosticDetail') {
    const isBigInterval = checkIsBigInterval();
    layout.value = false;
    if (isBigInterval) {
      warningPopup.value = true;
    } else {
      executeReport();
    }
  } else {
    layout.value = true;
  }
});

function processCallback(type: string, message: string, percent?: number) {
  const button = document.getElementById(props.buttonId);
  const targetSpan = getNeighborByClass_helper(button, 'target-show-span');

  const area = document.querySelector('#' + props.areaId);

  if (type === 'error') {
    const defaultErrorMessage =
      'Произошла ошибка, попробуйте повторить запрос, либо обновить страницу';
    if (button) {
      button.innerHTML = 'Выполнить отчет';
      setElementColor_helper(button, 'red');
      targetSpan.innerHTML = message || defaultErrorMessage;
    }
    if (area) {
      area.innerHTML = message || defaultErrorMessage;
    }
    emit('close');
  } else {
    if (button) {
      button.innerHTML = 'Выполнить отчет';
      targetSpan.innerHTML = message;
      setElementColor_helper(button, 'blue');
    }
    if (area) {
      area.innerHTML = message;
    }
  }
}

function executeReport() {
  const isWithDescription = props.reportName === 'descriptionDiagnostic';

  const report = new Diagnostic(isWithDescription);

  report.onProcess(processCallback);
  report.onSuccess((reportCalculated) => {
    reportCalculated.objects.sort((a, b) => a.name.localeCompare(b.name));
    const button = document.getElementById(props.buttonId);
    const targetSpan = getNeighborByClass_helper(button, 'target-show-span');
    targetSpan.innerHTML = 'Суммарный отчет построен. Выполнить новый запрос?';
    setElementColor_helper(button, 'green');
    clearReportArea();

    emit('close');
    if (props.areaId.startsWith('diagnostic-')) {
      let uiButton;
      if (props.areaId.endsWith('-detail')) {
        uiButton = document.getElementById(
          'ui-button-diagnostics-report-detalization',
        );
      } else {
        uiButton = document.getElementById('ui-button-diagnostics-report');
      }
      if (uiButton && !uiButton.classList.contains('btn-primary')) {
        uiButton.classList.add('btn-success');
      }
    }
    emit('displayReport', { data: reportCalculated, areaId: props.areaId });
  });
  report.getReport(
    {
      objects: props.objects,
      from: props.interval.from,
      to: props.interval.to,
      templateName: props.reportName,
    },
    {
      groupBy: groupBy.value,
      sortBy: sortBy.value,
      descending: descending.value,
    },
  );

  layout.value = false;
  warningPopup.value = false;
}

function checkIsBigInterval() {
  const { from, to } = props.interval;

  const unixInterval = +to - +from;
  const daysInInterval = unixInterval / 86400_000;

  return daysInInterval > MAX_DAYS_IN_INTERVAL;
}

function toggleDescending() {
  descending.value = !descending.value;
}

function closeHandler() {
  const backgroundWrap = document.getElementById('background-wrap');
  if (backgroundWrap) backgroundWrap.style.display = 'none';
  emit('close');
}

function clearReportArea() {
  const area = document.getElementById(props.areaId);
  if (area) {
    area.innerHTML = '';
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("strong", null, _toDisplayString(_unref(title)), 1),
          _hoisted_4,
          _hoisted_5
        ]),
        _createElementVNode("img", {
          class: "close",
          src: "/images/close.png",
          onClick: closeHandler
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        (props.reportName === 'diagnostic')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("table", null, [
                _createElementVNode("tr", null, [
                  _hoisted_8,
                  _createElementVNode("td", _hoisted_9, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((groupBy).value = $event)),
                      class: "px-1 py-1",
                      style: {"width":"150px"}
                    }, [
                      _hoisted_10,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GROUP_BY_OPTIONS), (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.value,
                          value: option,
                          innerHTML: option.label
                        }, null, 8, _hoisted_11))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, groupBy.value]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_12,
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sortBy).value = $event)),
                        class: "px-1 py-1",
                        style: {"width":"150px"}
                      }, [
                        _hoisted_15,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SORT_BY_OPTIONS), (option) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: option.value,
                            value: option,
                            innerHTML: option.label
                          }, null, 8, _hoisted_16))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, sortBy.value]
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-primary btn-sm ml-1",
                        style: {"margin":"0"},
                        innerHTML: descending.value ? '▲' : '▼',
                        onClick: toggleDescending
                      }, null, 8, _hoisted_17)
                    ])
                  ])
                ])
              ]),
              _hoisted_18
            ]))
          : _createCommentVNode("", true),
        _hoisted_19
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(UIReportButton, {
          "is-section-button": false,
          "is-form-submit": false,
          "template-button-id": 'shiftWork-template-setting-window-get-template-button',
          "button-additional-class": '',
          "hint-additional-class": '',
          onExecuteReport: executeReport
        })
      ])
    ], 512), [
      [_vShow, layout.value]
    ]),
    (warningPopup.value)
      ? (_openBlock(), _createBlock(UiPopup, {
          key: 0,
          onClose: closeHandler,
          "style-for-body": "padding: 10px; width: 300px; max-width: 300px",
          "z-index": "1003",
          "close-button": "",
          class: "my-popup"
        }, {
          header: _withCtx(() => [
            _hoisted_21
          ]),
          default: _withCtx(() => [
            _hoisted_22,
            _hoisted_23,
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createVNode(UIReportButton, {
                rounded: "",
                "no-caps": "",
                "is-section-button": false,
                "is-form-submit": false,
                "template-button-id": '',
                "button-additional-class": '',
                "hint-additional-class": '',
                onExecuteReport: executeReport
              }),
              _createElementVNode("button", {
                class: "btn btn-success btn-sm",
                onClick: closeHandler
              }, " Вернуться ")
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})